import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloPisoSpcPremium from '../components/sections/Piso-Spc-Premium/TituloSpcPremium';
import IntroPisoSpcPremium from '../components/sections/Piso-Spc-Premium/IntroPisoSpcPremium';
import ComposicionSpcPremium from '../components/sections/Piso-Spc-Premium/ComposicionSpcPremium';
import CaracteristicasGeneralesSpcPremium from '../components/sections/Piso-Spc-Premium/CaracteristicasGeneralesSpcPremium';
import ComparativaSpcPremium from '../components/sections/Piso-Spc-Premium/ComparativaSpcPremium';
import VideoSpcPremium from '../components/sections/Piso-Spc-Premium/VideoSpcPremium';
import CaracteristicaUnoSpcPremium from '../components/sections/Piso-Spc-Premium/CaracteristicaUnoSpcPremium';
import SellosSpcPremium from '../components/sections/Piso-Spc-Premium/SellosSpcPremium';
import PasosInstalacionSpcPremium from '../components/sections/Piso-Spc-Premium/PasosInstalacionSpcPremium';
import CatalogoProductoSpcPremium from '../components/sections/Piso-Spc-Premium/CatalogoProductoSpcPremium';
import FormularioContactoSpcPremium from '../components/sections/Piso-Spc-Premium/FormularioContactoSpcPremium';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

// Estilos unificados de toda la landing (acotados a .spc-premium-page)
import '../components/sections/Piso-Spc-Premium/PisoSpcPremium.css';

/*
  Orden de la landing (de lo general a la decisión):
  1. Qué es            → Título + Intro + Listo para instalar + Propiedades + Composición del SPC
  2. Por qué SPC       → Ventajas + Comparativa vs laminado
  3. Verlo e instalarlo→ Video + pasos de ensamblado y tutorial
  4. Elegir y cotizar  → Catálogo + Formulario
*/
const PisosSpcPages = () => {
  return (
    <div className="spc-premium-page">
      <SeoMetadata
        title="Piso SPC Premium | Decototal"
        description="Conoce los pisos SPC Premium: diseños para tus espacios con un acabado moderno y fácil mantenimiento. Revisa modelos y solicita una cotización."
        keywords="piso SPC premium, piso vinílico SPC, pisos SPC, piso de alta resistencia"
        path="/pisos-spc-premium"
        image="/assets/img/productos/pisos-spc-premium/piso-spc-luxury-header.jpeg"
      />
      <Header />

      {/* 1. Qué es */}
      <TituloPisoSpcPremium />
      <IntroPisoSpcPremium />
      <CaracteristicaUnoSpcPremium />
      <SellosSpcPremium />
      <ComposicionSpcPremium />

      {/* 2. Por qué SPC */}
      <CaracteristicasGeneralesSpcPremium />
      <ComparativaSpcPremium />

      {/* 3. Verlo e instalarlo */}
      <VideoSpcPremium />
      <PasosInstalacionSpcPremium />

      {/* 4. Elegir y cotizar */}
      <CatalogoProductoSpcPremium />
      <FormularioContactoSpcPremium />

      <Footer />
    </div>
  );
};

export default PisosSpcPages;